import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '@chegg-ui/theme';
import { LEGAL_COPY } from '../constants';
var LegalText = styled.small.withConfig({
  componentId: "sc-ox0g5n-0"
})(["font-size:11px;line-height:15px;margin-top:15px;color:", ";display:block;text-align:left;", ""], colors.grey, function (_ref) {
  var bottom = _ref.bottom;
  return bottom && css(["position:absolute;bottom:0;padding:0 30px 0 30px;"]);
});
export var LegalCopy = function LegalCopy(_ref2) {
  var bottom = _ref2.bottom;
  return /*#__PURE__*/React.createElement(LegalText, {
    className: "uw__legal-copy",
    bottom: bottom
  }, LEGAL_COPY);
};